import { render, staticRenderFns } from "./company-siren.vue?vue&type=template&id=3f924c26&scoped=true&"
import script from "./company-siren.vue?vue&type=script&lang=js&"
export * from "./company-siren.vue?vue&type=script&lang=js&"
import style0 from "./company-siren.vue?vue&type=style&index=0&id=3f924c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f924c26",
  null
  
)

export default component.exports